import { Types } from '../actions/configuracion';

export default function reclamosReducer(state = {
    loading: false
    , loadingDownload: false
    , terminos: ""
    , datosCuentaBancaria: ""
    , successUpdate: false
    , success: false
    , successFile: false
    , successGetTerminos:false
    , successTerminos:false
    , successPoliticaReclamos:false
    , successDownloadPoliticaReclamos:false
    , successDatosBancarios:false
    , error: false
}, action) {
    switch (action.type) {
        case Types.CONFIGURACION_LOADING:
            return {...state, loading: true }
        //Habilitar/Deshabilitar compra
        case Types.CONFIGURACION_UPDATE_SHOOP_ENABLED_REQUEST:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPDATE_SHOOP_ENABLED_SUCCEEDED:
            return {...state, loading: false, success: true, successFile: false, error: false};
        case Types.CONFIGURACION_UPDATE_SHOOP_ENABLED_ERROR:
            return {...state, loading: false, success: false, successFile: false, error: action.err,};
        //Cargar Lista de precio
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO_SUCCEEDED:
            return {...state, loading: false, success: false, successFile: true, error: false};
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO_ERROR:
            return {...state, loading: false, success: false, successFile: false, error: action.err,};
        //Cargar Lista de precio Herraje
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO_HERR:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO_HERR_SUCCEEDED:
            return {...state, loading: false, success: false, successFile: true, error: false};
        case Types.CONFIGURACION_UPLOAD_LISTA_PRECIO_HERR_ERROR:
            return {...state, loading: false, success: false, successFile: false, error: action.err,};
        //Cargar banco de imagenes
        case Types.CONFIGURACION_UPLOAD_BANCO_IMAGENES:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPLOAD_BANCO_IMAGENES_SUCCEEDED:
            return {...state, loading: false, success: false, successFile: true, error: false};
        case Types.CONFIGURACION_UPLOAD_BANCO_IMAGENES_ERROR:
            return {...state, loading: false, success: false, successFile: false, error: action.err,};
        //Cargar manual de marca
        case Types.CONFIGURACION_UPLOAD_MANUAL_MARCA:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPLOAD_MANUAL_MARCA_SUCCEEDED:
            return {...state, loading: false, success: false, successFile: true, error: false};
        case Types.CONFIGURACION_UPLOAD_MANUAL_MARCA_ERROR:
            return {...state, loading: false, success: false, successFile: false, error: action.err,};
        //Get terminos y condiciones
        case Types.CONFIGURACION_GET_TERMINOS_CONDICIONES:
            return {...state, loading: true }
        case Types.CONFIGURACION_GET_TERMINOS_CONDICIONES_SUCCEEDED:
            return {...state, terminos: action.terminos, loading: false, successGetTerminos: true, error: false};
        case Types.CONFIGURACION_GET_TERMINOS_CONDICIONES_ERROR:
            return {...state, loading: false, success: false, successGetTerminos: false, error: action.err,};
        //Update terminos y condiciones
        case Types.CONFIGURACION_UPDATE_TERMINOS_CONDICIONES:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPDATE_TERMINOS_CONDICIONES_SUCCEEDED:
            return {...state, loading: false, successTerminos: true, error: false};
        case Types.CONFIGURACION_UPDATE_TERMINOS_CONDICIONES_ERROR:
            return {...state, loading: false, successTerminos: false, error: action.err,};
        //Update Politica Reclamos
        case Types.CONFIGURACION_UPDATE_POLITICA_RECLAMO:
            return {...state, loading: true }
        case Types.CONFIGURACION_UPDATE_POLITICA_RECLAMO_SUCCEEDED:
            return {...state, loading: false, successPoliticaReclamos: true, error: false};
        case Types.CONFIGURACION_UPDATE_POLITICA_RECLAMO_ERROR:
            return {...state, loading: false, successPoliticaReclamos: false, error: action.err,};
        //Download Politica Reclamos        
        case Types.CONFIGURACION_DOWNLOAD_POLITICA_RECLAMO:
            return {...state, loadingDownload: true }
        case Types.CONFIGURACION_DOWNLOAD_POLITICA_RECLAMO_SUCCEEDED:
            return {...state, loadingDownload: false, successDownloadPoliticaReclamos: true, error: false};
        case Types.CONFIGURACION_DOWNLOAD_POLITICA_RECLAMO_ERROR:
            return {...state, loadingDownload: false, successDownloadPoliticaReclamos: false, error: action.err,};
        //Get datos cuenta bancaria
        case Types.GET_CUENTA_BANCARIA_REQUEST:
            return {...state, loading: true }
        case Types.GET_CUENTA_BANCARIA_SUCCEEDED:
            return {...state, loading: false, datosCuentaBancaria: action.datosCuentaBancaria, successDatosBancarios: true, error: false};
        case Types.GET_CUENTA_BANCARIA_ERROR:
            return {...state, loading: false, successDatosBancarios: false, error: action.err,};
        //Insert or Update datos cuenta bancaria
        case Types.UPDATE_CUENTA_BANCARIA_REQUEST:
            return {...state, loading: true }
        case Types.UPDATE_CUENTA_BANCARIA_SUCCEEDED:
            return {...state, loading: false, updateCuentaResponse: action.updateCuentaResponse, successDatosBancarios: true, error: false};
        case Types.UPDATE_CUENTA_BANCARIA_ERROR:
            return {...state, loading: false, successDatosBancarios: false, error: action.err,};
        //Delete datos cuenta bancaria
        case Types.DELETE_CUENTA_BANCARIA_REQUEST:
            return {...state, loading: true }
        case Types.DELETE_CUENTA_BANCARIA_SUCCEEDED:
            return {...state, loading: false, deleteCuentaResponse: action.deleteCuentaResponse, successDatosBancarios: true, error: false};
        case Types.DELETE_CUENTA_BANCARIA_ERROR:
            return {...state, loading: false, successDatosBancarios: false, error: action.err,};
        default:
            return state;
    }
}
